import { useContext } from 'react';
import { AccountFrameContext, type AccountFrameProps } from './account-frame';

/** An account dialog's frame: the site's modal, unless the app provides its own. */
export function AccountFrame(props: AccountFrameProps) {
  const frame = useContext(AccountFrameContext);
  return frame(props);
}
